/**
 * Created by Marcus Zhao 06/02/2020
 * Description:
 *
 * ------ maintenance history ------
 * 06/02/2020 Marcus Zhao - add firstName lastName jobFunction
 */
export class JobFunction {
    exist: Array<string>;
    new: Array<string>;
    static parse(serverResponse): JobFunction {
        {
            return {
                exist: serverResponse['exist'],
                new: serverResponse['new']
            };
        }
    }
}

export class WebAddress {
    Work: AddressDetail;
    Home: AddressDetail;
}

export class EmailDetail {
    address: string;
    name: string;
    primaryEmail = false;
}

export class PhoneDetail {
    phone: string;
    name: string;
    groupId?: string;
}

export class AddressDetail {
    country: string;
    street: string;
    street2: string;
    city: string;
    state: string;
    zip: string;
    name: string;
    originalAddress: string;
    latitude: number;
    longitude: number;
    callGoogle?: boolean;
    geocodeSearched?: boolean;
}

export class RelationshipDetail {
    relationshipType: string;
    childEntity: Array<string>;
}

export class EmploymentDetail {
    companyID: string;
    startDate: Number;
    endDate?: Number;
    titleType: Array<string>;
}

export class SocialMedia {
    name: string;
    link: string;
}
